import React from "react";
import styles from "./non-academic-stat-institution.module.css";
import CustomTag from "../../common/custom-tag/custom-tag";
import SVGIcon from "../../constants/SVGIcon";
import { PieChart, Pie, Cell } from "recharts";
import { cardColorArr } from "../../constants/common";
import { EllipsisOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";

const NonAcademicInstitutionCard = ({
  level,
  total_students,
  total_male,
  total_female,
  chart_label_1,
  chart_label_2,
  chart_color_1,
  chart_color_2,
  total_medals,
  teacher_name,
  handleEdit,
  handleDelete,
}) => {
  const data = [
    { name: chart_label_1, value: Number(total_male) },
    { name: chart_label_2, value: Number(total_female) },
  ];

  const COLORS = [chart_color_1, chart_color_2];

  const randomIndex = Math.floor(Math.random() * cardColorArr.length);

  const getColorIndexFromLevel = (level) => {
    let hash = 0;
    for (let i = 0; i < level.length; i++) {
      hash = level.charCodeAt(i) + ((hash << 5) - hash);
    }
    return Math.abs(hash) % cardColorArr.length;
  };

  const index = getColorIndexFromLevel(level);

  const colorStyle = cardColorArr[index];

  const items = [
    {
      key: "1",
      label: <div onClick={handleEdit}>Edit</div>,
    },
    {
      key: "2",
      label: <div onClick={handleDelete}>Delete</div>,
    },
  ];

  return (
    <div
      className={styles.academic_nonacademic_stat_card}
      style={{
        background: cardColorArr[randomIndex]?.background,
        border: `1px solid ${cardColorArr[randomIndex]?.border}`,
      }}
    >
      <div className={styles.card_header}>
        <p className={styles.level_text}>{level}</p>
        <div>
          <Dropdown menu={{ items }} trigger="click" placement="bottomLeft">
            <EllipsisOutlined style={{ fontSize: 20, cursor: "pointer" }} />
          </Dropdown>
        </div>
      </div>
      <div className={styles.academic_nonacademic_stat_card_top}>
        <div className={styles.academic_nonacademic_stat_card_top_left}>
          <>
            <CustomTag
              text={teacher_name}
              color={colorStyle?.color}
              background={colorStyle?.background}
              borderColor={colorStyle?.border}
              handleToggleChecked={() => {}}
            />
            <p
              className={
                styles.academic_nonacademic_stat_card_top_left_teachers
              }
            >
              <SVGIcon
                name="badge-icon"
                width="20"
                height="20"
                className="anticon"
                stroke="rgba(136, 136, 136, 1)"
              />
              <span>Medals: {total_medals}</span>
            </p>
          </>
        </div>
        <div className={styles.academic_nonacademic_stat_card_top_right}>
          <PieChart width={52} height={52}>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              outerRadius={25}
              innerRadius={23}
              dataKey="value"
              stroke="none"
              fill="none"
              isAnimationActive={false}
              paddingAngle={12}
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill="none"
                  stroke={COLORS[index]}
                  strokeWidth={2}
                  strokeLinejoin="round"
                />
              ))}
            </Pie>
          </PieChart>
          <div className={styles.total_container}>
            <span>{total_students}</span>
            <span>Total</span>
          </div>
        </div>
      </div>
      <div className={styles.bottom}>
        <p className={styles.bottom_males}>
          <span className={styles.males_marker}></span>
          <span className={styles.total_gender}>Male:&nbsp;{total_male}</span>
        </p>
        <p className={styles.bottom_females}>
          <span className={styles.females_marker}></span>
          <span className={styles.total_gender}>
            Female:&nbsp;{total_female}
          </span>
        </p>
      </div>
    </div>
  );
};
export default NonAcademicInstitutionCard;
